// Answers must stay factual — practitioners sign off before `reviewed` flips.
export const faqReviewed = false

export const faqGroups = [
  {
    title: 'Booking & visiting',
    items: [
      {
        id: 'location',
        q: 'Where is Recreo Rehab located?',
        a: 'We are at 161 Eglinton Avenue East, Unit 206, in Midtown Toronto near Yonge & Eglinton. Use the commercial entrance on Redpath Avenue.',
      },
      {
        id: 'hours',
        q: 'What are your hours?',
        a: 'Monday to Friday, 8:30 am to 8:30 pm, and Saturday, 8:30 am to 2:30 pm. We are closed on Sunday. You can book online at any time.',
      },
      {
        id: 'booking',
        q: 'How do I book an appointment?',
        a: 'Book online through our Jane booking page, where you can choose your practitioner, service, and appointment length. You can also call us at (416) 826-2497 or email info@recreorehab.com.',
      },
      {
        id: 'first-visit',
        q: 'What should I expect at my first visit?',
        a: 'Your practitioner starts by talking through your history and goals, then assesses how you move. Treatment is tailored to what they find, and you leave with a clear plan, which often includes simple exercises to do at home.',
      },
      {
        id: 'what-to-wear',
        q: 'What should I wear?',
        a: 'Wear comfortable clothing you can move in. For athletic therapy and movement assessments, shorts and a t-shirt make it easier to assess and treat the area.',
      },
    ],
  },
  {
    title: 'Services',
    items: [
      {
        id: 'services',
        q: 'What services does Recreo Rehab offer?',
        a: 'Registered Massage Therapy, Athletic Therapy, and naturopathic medicine. Our practitioners may also include acupuncture, cupping, TMJ and jaw care, prenatal and postpartum care, and sports and active recovery work, depending on your needs.',
      },
      {
        id: 'rmt-vs-at',
        q: 'Should I book massage therapy or athletic therapy?',
        a: 'Massage therapy is a good fit for pain, tension, stress, and ongoing maintenance, with a focus on hands-on treatment. Athletic therapy focuses on assessing and rehabilitating musculoskeletal injuries, with more emphasis on exercise and return to activity. If you are unsure, contact us and we will point you to the right practitioner.',
      },
      {
        id: 'acupuncture',
        q: 'Do you offer acupuncture?',
        a: 'Yes. Several of our Registered Massage Therapists are Contemporary Medical Acupuncture providers and may include acupuncture in a massage therapy session. Our naturopathic doctor also offers acupuncture, including facial acupuncture.',
      },
      {
        id: 'tmj',
        q: 'Do you treat TMJ and jaw pain?',
        a: 'Yes. TMJ and jaw care is provided within massage therapy sessions by practitioners with advanced TMJ and intra-oral training.',
      },
    ],
  },
  {
    title: 'Pricing & insurance',
    items: [
      {
        id: 'pricing',
        q: 'How much does an appointment cost?',
        a: 'Massage therapy starts at $100 for 30 minutes. Athletic therapy starts at $90 for 30 minutes, with a $140 initial assessment. Naturopathic medicine starts with a free 15-minute consultation, and a 60-minute initial visit is $250. See our Services page for full pricing.',
      },
      {
        id: 'billing',
        q: 'Do you offer direct billing to insurance?',
        a: 'Direct billing is available where applicable. Coverage depends on your extended health plan and on the type of care: massage therapy, athletic therapy, and naturopathic medicine are billed separately. Acupuncture and TMJ care provided in a massage session are billed as massage therapy. Check your plan or contact us before your visit.',
      },
      {
        id: 'receipts',
        q: 'Will I get a receipt for insurance?',
        a: 'Yes. You receive a receipt from your registered practitioner that you can submit to your insurance provider if we cannot bill them directly.',
      },
    ],
  },
]

export const allFaqs = faqGroups.flatMap((g) => g.items)

export const faqsById = (ids) =>
  ids.map((id) => allFaqs.find((f) => f.id === id)).filter(Boolean)

export const faqSchema = (items) => ({
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: items.map((f) => ({
    '@type': 'Question',
    name: f.q,
    acceptedAnswer: { '@type': 'Answer', text: f.a },
  })),
})
